var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphAnxietyDepressed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.373 38.239 1.051.382a2.237 2.237 0 0 1 1.338 2.867h-.001l-3.826 10.508a2.239 2.239 0 0 1-2.867 1.338l-1.051-.383a2.237 2.237 0 0 1-1.338-2.867l3.826-10.508a2.239 2.239 0 0 1 2.868-1.337z",
    fill: "#7088C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.795 43.522 1.05.382a2.237 2.237 0 0 1 1.338 2.867L31.766 69.89a2.239 2.239 0 0 1-2.868 1.337l-1.05-.383a2.237 2.237 0 0 1-1.339-2.867h.001l8.417-23.118a2.239 2.239 0 0 1 2.868-1.337z",
    fill: "#B1C1E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.133 37.458 1.051.382a2.237 2.237 0 0 1 1.337 2.868L50.783 56.47a2.239 2.239 0 0 1-2.868 1.337l-1.051-.382a2.237 2.237 0 0 1-1.338-2.868l5.74-15.762a2.239 2.239 0 0 1 2.867-1.337z",
    fill: "#7088C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.437 32.32c-1.057 0-1.876-1.027-1.745-2.188.972-8.61 7.607-15.273 15.647-15.273s14.675 6.662 15.647 15.273c.131 1.161-.688 2.189-1.744 2.189H43.437z",
    fill: "#7A6694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.372 32.366c-1.354 0-2.403-1.316-2.235-2.803C18.383 18.534 26.88 10 37.18 10c10.298 0 18.795 8.534 20.041 19.563.168 1.487-.882 2.803-2.235 2.803H19.372z",
    fill: "#A396B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.325 32.303c-.796 0-1.414-.774-1.315-1.65.733-6.487 5.732-11.507 11.79-11.507 6.057 0 11.056 5.02 11.789 11.508.098.875-.52 1.649-1.315 1.649H8.324z",
    fill: "#7A6694"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphAnxietyDepressed);
export default __webpack_public_path__ + "static/media/icons_graph_anxiety_depressed.49baa27cf76266e4d31597317fa3bca5.svg";
export { ForwardRef as ReactComponent };